import { combineReducers } from 'redux';
import undoableInstanceEditingReducer from './undoableInstanceEditingReducer';
export const structuredContent = combineReducers({
  instanceEditing: undoableInstanceEditingReducer
});